import { appStore } from '../../app/AppStore';
import { SessionSiteSelectors } from '../../app/selectors/SessionInfoSelectors';
import { NaturalLanguageProps } from '../../common/react/components/NaturalLanguage';
import { IDataSourceDetailInfo } from '../models/IDataSourceInfo';
import { Module } from '../Module';
import { IDatasourceActions } from '../ServerApi/types/IDatasourceActions';
import { BrowserTitleService } from '../services/BrowserTitleService';

export interface INaturalLanguageScope extends ng.IScope {
  naturalLanguageProps: NaturalLanguageProps;
}

export class NaturalLanguageCtrl {
  public static $inject = [
    '$state',
    '$scope',
    'BrowserTitleService',
    'datasourceDetailInfo',
    'datasourceActions',
  ];

  constructor(
    $state: ng.ui.IStateService,
    $scope: INaturalLanguageScope,
    browserTitleService: BrowserTitleService,
    dataSourceDetailInfo: IDataSourceDetailInfo,
    datasourceActions: IDatasourceActions,
  ) {
    browserTitleService.setTitleWithPlaceEntityNameAndSubplaceName({
      placeEntityName: dataSourceDetailInfo.name,
      translatableSubplaceName: 'nlpTab'
    });

    $scope.naturalLanguageProps = {
      dataSourceUrlName: dataSourceDetailInfo.urlName,
      siteUrlName: SessionSiteSelectors.siteUrlName(appStore.getState())
    };

    if(!datasourceActions.showNlp) {
      $state.go('main.site.content.datasource.connections', null, { location: 'replace' });
    }
  }
}

Module.instance().controller('NaturalLanguageCtrl', NaturalLanguageCtrl);
